"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMTGFuturesParamsCheck = exports.queryMTGFParamsCheck = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const BotAPI_1 = require("../../BotAPI");
const lodash_1 = require("lodash");
function beforeMTGFuturesCheckRequest(params) {
    if (new trade_utils_lib_1.SafeDecimal(params.price_scale_param || 0).isZero()) {
        throw { code: -1, message: "params not valid" };
    }
    if (new trade_utils_lib_1.SafeDecimal(params.safety_orders || 0).isZero()) {
        throw { code: -1, message: "params not valid" };
    }
    return {
        quote: params.quote,
        trend: params.trend,
        leverage: params.leverage,
        extra_margin: params.extra_margin,
        quote_investment: params.quote_investment || undefined,
        extra_margin_amount: params.extra_margin_amount || undefined,
        portfolio: [
            {
                open_price: params.open_price,
                base: params.base,
                price_scale_type: params.price_scale_type,
                price_scale_param: params.price_scale_param,
                safety_orders: params.safety_orders,
                volume_scale: params.volume_scale,
            },
        ],
    };
}
const parseMTGFuturesCheckResult = (response, invest_precision, isAutoExtraMargin) => {
    const { esInvest, esExtraM } = (() => {
        let tradeInvest = "";
        let marginInvest = "";
        if (Number(response.estimate_investment)) {
            if (!isAutoExtraMargin) {
                tradeInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(response.estimate_investment, invest_precision);
                marginInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(response.estimate_extra_margin, invest_precision);
            }
            else {
                const totalInvest = new trade_utils_lib_1.SafeDecimal(response.estimate_investment).add(new trade_utils_lib_1.SafeDecimal(response.estimate_extra_margin));
                tradeInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(response.estimate_investment, invest_precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
                marginInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(totalInvest).sub(new trade_utils_lib_1.SafeDecimal(tradeInvest)), invest_precision, trade_utils_lib_1.SafeDecimal.ROUND_DOWN);
            }
        }
        return { esInvest: tradeInvest, esExtraM: marginInvest };
    })();
    const result = Object.assign(Object.assign({}, response), { minInvestment: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(response.min_investment, invest_precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL), maxInvestment: trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(response.max_investment, invest_precision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR), estimateInvestment: esInvest, estimateExtraMargin: esExtraM });
    return result;
};
const queryMTGFParamsCheck = (request, options) => {
    return (0, rxjs_1.of)(request).pipe((0, rxjs_1.map)((params) => beforeMTGFuturesCheckRequest(params)), (0, rxjs_1.switchMap)((params) => {
        return (0, BotAPI_1.MTGFuturesParamsCheck)(params);
    }), (0, rxjs_1.map)((res) => parseMTGFuturesCheckResult(res, options.investPrecision, request.extra_margin)));
};
exports.queryMTGFParamsCheck = queryMTGFParamsCheck;
const useMTGFuturesParamsCheck = (_params, _options, { inputError }) => {
    const { open_price, quote_investment, trend, quote, base, leverage, extra_margin_amount, is_copy_bot, price_scale_param, safety_orders, volume_scale, } = _params;
    const [checkResult, setCheckResult] = (0, react_1.useState)();
    const [checkLoading, setCheckLoading] = (0, react_1.useState)(false);
    const requestRef = (0, react_1.useRef)(_params);
    requestRef.current = _params;
    const optionsRef = (0, react_1.useRef)(_options);
    optionsRef.current = _options;
    const debounceFn = (0, react_1.useRef)((0, lodash_1.debounce)(() => {
        const sub = (0, rxjs_1.of)(requestRef.current)
            .pipe((0, rxjs_1.map)((params) => {
            return beforeMTGFuturesCheckRequest(params);
        }), (0, rxjs_1.switchMap)((params) => {
            return (0, BotAPI_1.MTGFuturesParamsCheck)(params);
        }), (0, rxjs_1.map)((res) => parseMTGFuturesCheckResult(res, optionsRef.current.investPrecision, requestRef.current.extra_margin)))
            .subscribe({
            next: (resp) => {
                setCheckResult(resp);
                setCheckLoading(false);
            },
            error: (err) => {
                setCheckLoading(false);
            },
        });
        return sub;
    }, 500));
    // 价格改变不加loading
    (0, react_1.useEffect)(() => {
        var _a;
        // 输入报错
        if (inputError) {
            return;
        }
        // open_price 为0或者不存在提前拦截
        if (new trade_utils_lib_1.SafeDecimal(open_price || 0).equals(0)) {
            return;
        }
        if (!trend || !quote || !base || !leverage || !safety_orders || !volume_scale) {
            return;
        }
        const sub = (_a = debounceFn.current) === null || _a === void 0 ? void 0 : _a.call(debounceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open_price]);
    (0, react_1.useEffect)(() => {
        var _a;
        // 输入报错
        if (inputError) {
            return;
        }
        // open_price 为0或者不存在提前拦截
        if (new trade_utils_lib_1.SafeDecimal(open_price || 0).equals(0)) {
            return;
        }
        if (!trend || !quote || !base || !leverage || !safety_orders || !volume_scale) {
            return;
        }
        setCheckLoading(true);
        const sub = (_a = debounceFn.current) === null || _a === void 0 ? void 0 : _a.call(debounceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quote_investment, trend, quote, base, leverage, extra_margin_amount, is_copy_bot, price_scale_param, safety_orders, volume_scale]);
    return { checkLoading, checkResult };
};
exports.useMTGFuturesParamsCheck = useMTGFuturesParamsCheck;
